"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRollbar = getRollbar;
exports.setRollbar = setRollbar;
exports.setStore = setStore;

var _invariant = _interopRequireDefault(require("invariant"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _getOptions = _interopRequireDefault(require("./helpers/get-options"));

var rollbar;
var store;
/**
 * Set the redux store for later use by this module. This should be set immediately upon creation
 * of the store used by the application.
 * @param {Object} reduxStore - a redux store
 */

function setStore(reduxStore) {
  if (!store) {
    store = reduxStore;
  }
}

function setRollbar(rollbarInstance) {
  if (!rollbar) {
    rollbar = rollbarInstance;
  }
}
/**
 * Get the current instance and pass to provided callback `fn`. `fn` will be provided with the
 * parameters (instance, extra) where `instance` is an instance of the Rollbar class and `extra` is
 * the additional environmental data from calling `getOptions` in this module.
 *
 * @param {Function} fn - callback function to pass instance of Rollbar to.
 */


function getRollbar(fn) {
  (0, _invariant.default)((0, _isObject.default)(rollbar), 'Rollbar instance must be set when calling createRollbarMiddleware');

  try {
    if (store) {
      fn(rollbar, (0, _getOptions.default)({}, store));
    } else {
      fn(rollbar);
    }
  } catch (error) {
    rollbar.error(error);
  }
}